import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

/**
 * A responsive footer component for the investment platform.
 * Built with Tailwind CSS for utility-first styling.
 *
 * Features:
 * - A main section for the legal disclaimer text.
 * - A bottom bar for the copyright notice.
 * - Styled with dark-themed colors to match the top bar of the Navbar.
 */
const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="text-gray-300 mt-auto" style={{ backgroundColor: '#1B3A5C' }}>
      {/* SECTION: Main Footer Content (Disclaimer) */}
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-8">
        <div className="text-xs text-justify leading-relaxed">
          <p>
            {t('footer.disclaimer')}
          </p>
        </div>
      </div>

      {/* SECTION: Bottom Bar (Copyright) */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-3">
          <p className="text-center text-xs text-white leading-relaxed">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
